import { Link, useLocation } from 'react-router-dom'

interface AdminLayoutProps {
  children: React.ReactNode
}

export default function AdminLayout({ children }: AdminLayoutProps) {
  const location = useLocation()
  
  const tabs = [
    { path: '/admin', label: 'Packs', exact: true },
    { path: '/admin/crm', label: 'CRM' },
    { path: '/admin/automations', label: 'Automations' },
  ]
  
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b border-gray-200">
        <div className="container-custom py-4">
          <div className="flex items-center justify-between">
            <h1 className="text-2xl font-bold text-gray-900">Harbor Agent Admin</h1>
            <nav className="flex space-x-1">
              {tabs.map((tab) => {
                const isActive = tab.exact
                  ? location.pathname === tab.path
                  : location.pathname.startsWith(tab.path)
                
                return (
                  <Link
                    key={tab.path}
                    to={tab.path}
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                      isActive
                        ? 'bg-primary-600 text-white'
                        : 'text-gray-600 hover:bg-gray-100'
                    }`}
                  >
                    {tab.label}
                  </Link>
                )
              })}
            </nav>
          </div>
        </div>
      </div>
      <div className="container-custom py-8">
        {children}
      </div>
    </div>
  )
}

